import React from 'react'
import { ModalConsulta } from '.';
import { Tabela } from '../Basicos';
import { dateAndHourLaravel } from '../Basicos/funcoes';

function ModalConsultaAlteracoesConteudoProva(props) {
    const { estrutura } = props;
    const { alteracoes } = estrutura?.modal;

    const columns = React.useMemo(
        () => [
            {
                Header: 'Título da Prova',
                accessor: 'titulo',
            },
            {
                Header: 'Semestre',
                accessor: 'semestre',
            },
            {
                Header: 'Turma',
                accessor: 'turma',
            },
            {
                Header: 'Título da Aula',
                accessor: 'titulo_aula',
            },
            {
                Header: 'Descrição da Alteração',
                accessor: 'descricao',
            },
            {
                Header: 'Data da Alteração',
                accessor: 'data_evento',
                Cell: ({ row }) => row.original.data_evento ? dateAndHourLaravel(row.original.data_evento) : '-'
            }
        ],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"
            {...props}
        >
            <Tabela
                columns={columns}
                data={alteracoes}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalConsultaAlteracoesConteudoProva;
